import React, { useEffect, useState } from 'react';
import '../CSS/Global.css'; // Ensure your CSS file path is correct
import { useNavigate } from 'react-router-dom';
import productadd from "../Images/productadd.png"
import { Spinner, useToast } from '@chakra-ui/react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { v4 as uuid } from "uuid";

const AddProject = () => {
    const [productName, setProductName] = useState('');
    const [mrp, setMrp] = useState('');
    const [sellingPrice, setSellingPrice] = useState('');
    const [shortDescription, setShortDescription] = useState('');
    const [image, setImage] = useState()
    const login = JSON.parse(localStorage.getItem("login")) || ""
    let navigate = useNavigate()
    const [units, setUnits] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState('');
    const [quantity, setSelectedQuantity] = useState('');
    const toast = useToast()
    const [load, setLoad] = useState(true);
    const [showAdditional, setShowAdditional] = useState(false);
    const [credits, setCredits] = useState(0);
    const [showCastSection, setShowCastSection] = useState(false);
    const [castList, setCastList] = useState([]);
    const [selfList, setSelfList] = useState([]);
    const [dateLaunched, setDateLaunched] = useState('');
    const quillRef = React.useRef(null);
    const [quill, setQuill] = useState(null);







    const handleImageUpload = (event) => {
        const file = event.target.files[0]; // Get the first file from input
        setImage(file); // Store the selected image in state
    };

    // Add form submission logic here

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoad(false);
        // Create FormData object to send image along with other data
        const formData = new FormData();
        formData.append('product_image', image);
        formData.append('product_name', productName);
        formData.append('mrp_price', mrp);
        formData.append('sell_price', sellingPrice);
        formData.append('quantity', quantity);
        formData.append('unit', selectedUnit);
        formData.append('description', shortDescription);
        formData.append('datelaunched', dateLaunched);
        formData.append('user_id', login.permanent_ID);
        formData.append('user_name', login.name);
        formData.append('castlist', JSON.stringify(castList))
        formData.append('type', 'portfolio');

        try {
            // Replace with your backend API URL
            const apiBase = process.env.REACT_APP_URL || '';
            const response = await fetch(`${apiBase}/product/add-product/${login.permanent_ID}`, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();
            console.log('Image uploaded:', result);
            if (response.ok) {
                toast({
                    description: `Product added successfully`,
                    status: 'success',
                    duration: 5000,
                    position: 'top-center',
                    isClosable: true,
                });
                navigate(-1)
                setLoad(true)
            }
        } catch (error) {
            console.log('Error uploading image:', error);
            setLoad(true)
        }
        // console.log({
        //   productName,
        //   mrp,
        //   sellingPrice,
        //   shortDescription,
        // });
    };

    const [category, setCategory] = useState();

    const handleDescriptionChange = (value) => {
        const editor = quillRef.current?.getEditor();
        if (!editor) return;  // prevent null errors

        const plain = editor.getText().trim();

        if (plain.length > 1000) {
            editor.deleteText(1000, plain.length); // THIS WORKS NOW
            return;
        }

        setShortDescription(value);
    };






    const fetchDataUser = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/store/getstorelist/mystore/${login.permanent_ID}`);
            const store = await response.json();
            console.log(store);
            setCategory(store.category)
        } catch (error) {
            console.log(error);
        }
    }

    const fetchCategory = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/category/singlecategory/${category}`);
            const res = await response.json();
            console.log(res);

            // Parse the units field
            if (res.units) {
                const parsedUnits = JSON.parse(res.units);
                console.log('Parsed Units:', parsedUnits);
                setUnits(parsedUnits);
            } else {
                console.log('Units field is not available');
            }
        } catch (error) {
            console.log(error);
        }
    };

    const updateCastField = (index, field, value) => {
        const updated = [...castList];
        if (!updated[index]) updated[index] = {};
        updated[index][field] = value;
        setCastList(updated);
    };

    const updateSelfField = (index, field, value) => {
        const updated = [...selfList];
        if (!updated[index]) updated[index] = {};
        updated[index][field] = value;
        setSelfList(updated);
    };

    const handleCastImageUpload = (e, index) => {
        const file = e.target.files[0];
        updateCastField(index, "image", file);
    };

    const handleSelfImageUpload = (e, index) => {
        const file = e.target.files[0];
        updateSelfField(index, "image", file);
    };




    useEffect(() => {
        if (category) {
            fetchCategory();
        }
    }, [category]);


    useEffect(() => {
        fetchDataUser();
        // fetchCategory();
    }, [])
    const creditRows = Array.from({ length: credits / 10 }, (_, i) => i + 1);



    return (
        <div className="product-container">
            <div className="product-image-column">
                <img
                    src={productadd}
                    alt="Product"
                    className="product-image"
                />
            </div>
            <div className="product-form-column">
                <h2>List Your Project </h2>
                <form onSubmit={handleSubmit}>
                    <div className="product-form-group">
                        <label>Title:</label>
                        <input
                            type="text"
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            placeholder="Enter title"
                            required
                        />
                    </div>
                    <div className="product-form-group">
                        <label>Upload Image (Optional):</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageUpload}

                        />
                    </div>
                    <div className="product-form-group">
                        <label>Date Launched:</label>
                        <input
                            type="date"
                            value={dateLaunched}
                            onChange={(e) => setDateLaunched(e.target.value)}
                            required
                        />
                    </div>

                    <div className="product-form-group">
                        <label>Description (max 1000 chars):</label>

                        <ReactQuill
                            ref={quillRef}
                            theme="snow"
                            value={shortDescription}
                            onChange={handleDescriptionChange}
                            placeholder="Description"
                            style={{ height: "120px" }}
                        />
                    </div>
                    {/* <p style={{ fontSize: "12px", marginTop: "5px", color: "#555" }}>
                        {shortDescription.replace(/<[^>]+>/g, "").trim().length} / 1000 characters
                    </p> */}

                    <div className="product-form-group" style={{ marginTop: "50px" }}>
                        <label style={{ fontWeight: "600" }}>Additional Details</label>
                        <div
                            onClick={() => setShowAdditional(!showAdditional)}
                            className="toggle-btn"
                            style={{
                                width: "60px",
                                height: "30px",
                                background: showAdditional ? "var(--red)" : "#ccc",
                                borderRadius: "20px",
                                cursor: "pointer",
                                position: "relative",
                                transition: "0.3s",
                                marginBottom: "10px"
                            }}
                        >
                            <div
                                style={{
                                    width: "26px",
                                    height: "26px",
                                    background: "#fff",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    top: "2px",
                                    left: showAdditional ? "32px" : "2px",
                                    transition: "0.3s"
                                }}
                            ></div>
                        </div>
                    </div>

                    {showAdditional && (
                        <div className="lfproject-additional-box">

                            {/* Credits Dropdown */}
                            <div className="lfproject-credit-box">
                                <label>Add Credits:</label>

                                <select
                                    className="lfproject-credit-select"
                                    value={credits}
                                    onChange={(e) => {
                                        const value = Number(e.target.value);
                                        setCredits(value);

                                        // Create EXACT number of cast rows (new object each row)
                                        setCastList(
                                            Array.from({ length: value }, () => ({
                                                id: uuid(),
                                                name: "",
                                                character: ""
                                            }))
                                        );

                                        setShowCastSection(true);
                                    }}
                                >
                                    <option value={0}>Select Credits</option>
                                    {[10, 20, 30, 40, 50, 60, 70, 80, 90].map((c) => (
                                        <option key={c} value={c}>
                                            Add {c} Credits
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {/* Cast Section */}
                            {showCastSection && (
                                <div className="lfproject-credits-wrapper">

                                    <h2 className="lfproject-title">Cast and Crew</h2>
                                    {/* <h3 className="lfproject-subtitle">Cast</h3> */}

                                    {castList.map((item, index) => (
                                        <div key={index} className="lfproject-cast-box">

                                            <div className="lfproject-cast-header">
                                                New #{index + 1}

                                                {/* DELETE BUTTON */}
                                                <button
                                                    type='button'
                                                    className="lfproject-delete-btn"
                                                    onClick={() => {
                                                        const updated = [...castList];
                                                        updated.splice(index, 1);
                                                        setCastList(updated);
                                                    }}>
                                                    <i class="fa-solid fa-xmark"></i>
                                                </button>
                                            </div>

                                            <div className='lfnew-divflesing'>
                                                <div className="lfproject-input-group">
                                                    <label>Name</label>
                                                    <input
                                                        type="text"
                                                        className="lfproject-text-input"
                                                        value={item.name}
                                                        onChange={(e) => {
                                                            const updated = [...castList];
                                                            updated[index].name = e.target.value;
                                                            setCastList(updated);
                                                        }}

                                                    />
                                                </div>

                                                <div className="lfproject-input-group">
                                                    <label>Role</label>
                                                    <input
                                                        type="text"
                                                        className="lfproject-text-input"
                                                        value={item.character}
                                                        onChange={(e) => {
                                                            const updated = [...castList];
                                                            updated[index].character = e.target.value;
                                                            setCastList(updated);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    ))}

                                </div>
                            )}
                        </div>
                    )}




                    {
                        load ? <button type="submit" className="product-submit-button">Add Project</button> :
                            <button className="product-submit-button"><Spinner /></button>
                    }
                </form>
            </div>
        </div>
    );
};

export default AddProject;
